import Http from "./http";

export const getEnrollmentAgreementListAPI = (payload) => {
  return Http.post("admin/campaign/enrollment-agreement/list", payload);
};

